// extracted by mini-css-extract-plugin
export default {"wrapper":"SingleApartmentMap_wrapper__nV3r6"};